import {Component, Inject, OnInit} from '@angular/core';
import {Category} from "../../../shared/models/category";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {PrinterDto} from "../../../shared/models/printer-dto";
import {Tenant} from "../../../shared/models/tenant";
import {PrinterCategoryQueueAssignmentDto} from "../../../shared/models/printer-category-queue-assignment-dto";

@Component({
  selector: 'app-printer-details-popup',
  templateUrl: './printer-details-popup.component.html',
  styleUrl: './printer-details-popup.component.scss'
})
export class PrinterDetailsPopupComponent implements OnInit {

  printer: PrinterDto;
  printerForm: FormGroup;

  tenants: Tenant[] = [];
  printCategories: PrinterCategoryQueueAssignmentDto[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<PrinterDetailsPopupComponent>) {
    this.printer = data.item;
    this.printCategories = data.printCategories;
    this.tenants = data.tenants;
    this.printerForm = this.formBuilder.group({
      name: [this.printer.name, Validators.required],
      location: [this.printer.location, Validators.required],
      ipAddress: [this.printer.ipAddress, Validators.required],
      port: [this.printer.port, Validators.required],
      printCategoryIdentifier: [this.printer.printCategoryIdentifier, Validators.required],
      tenantId: [this.printer.tenantId, Validators.required],
      backupForOtherCategories: [this.printer.backupForOtherCategories, Validators.required]
    });
  }

  ngOnInit() {
  }

  onSubmit() {
    if (this.printerForm.valid) {
      const editedPrinter: PrinterDto = this.printerForm.value;
      this.dialogRef.close(editedPrinter);
    }
  }

}
